import {
    SimplePageContentWrapper,
    SimplePageLayout
} from '@flexinet/ui-components';

import {IndexPageHeader} from '../components/IndexPageHeader';
import {IndexPageNavigation} from "../navigation/IndexPageNavigation";
import {RecordsTable} from "../tables/RecordsTable.tsx";

// FNP-331: optional priceId switches the embedded RecordsTable to the
// cross-subscription "items by price" hook. Used by the prices detail page
// Subscriptions tab.
export const IndexPage = ({ subscriptionId, priceId }: { subscriptionId?: string, priceId?: string } = {}) => {

    return (
        <SimplePageLayout
            pageHeader={<IndexPageHeader/>}
            pageNavigation={<IndexPageNavigation/>}
        >
            <SimplePageContentWrapper><RecordsTable subscriptionId={subscriptionId} priceId={priceId}/></SimplePageContentWrapper>
        </SimplePageLayout>
    );
};
